// extracted by mini-css-extract-plugin
export default {"background":"SearchBar_background__iizqc","visible":"SearchBar_visible__UtuZt"};